import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { ChipModule } from 'primeng/chip';
import { TooltipModule } from 'primeng/tooltip';
import { AutomaticMeasureFrequencies } from '../../../types/measure.interface';
import { FrequencyUtils } from '../../../utils/frequency.utils';

import { CesTooltipAutoDismissDirective } from '../../../directives/ces-tooltip-auto-dismiss.directive';
@Component({
  standalone: true,
  selector: 'ces-property',
  imports: [CesTooltipAutoDismissDirective, CommonModule, ChipModule, TranslocoModule, TooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ces-property.component.html',
  styleUrl: './ces-property.component.scss',
})
export class CesProperty {
  @Input() public label: string = '';
  @Input() public chips: string[] = [];
  @Input() public type: string = '';
  @Input() public value: AutomaticMeasureFrequencies | undefined;
  @Input() public booleanValue: boolean | undefined;
  @Input() public tooltip: string = '';

  protected readonly FrequencyUtils = FrequencyUtils;
}
